import { stringsFor } from '../../location/locales';

const currentLocale = document.querySelector('html').getAttribute('lang');

const analyticNames = stringsFor(currentLocale).shingles.price_ranges;

const priceRanges = stringsFor(currentLocale)
  .shingles.price_ranges.map((name, idx) => ({ uid: `${idx + 1}`, name, analyticsName: analyticNames[idx] }))
  .reverse();

export default priceRanges;
